import { render, staticRenderFns } from "./PersonDeleteDialog.vue?vue&type=template&id=0180884a&"
import script from "./PersonDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./PersonDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports